<template>
  <article class="relative">
    <div
      v-for="(doc, index) in docs"
      :key="index"
      class="flex items-center justify-center h-7 w-16 rounded-full shadow-lg font-bold bg-bgr border border-brd transition-all duration-75 first:hover:bg-thm-hover first:hover:text-thm-contrast first:hover:border-0"
      :class="{
        relative: index === 0,
        absolute: index > 0,
        'first:border-0 first:bg-thm first:text-thm-contrast': selected,
        'first:border-0 first:text-thm': visited,
      }"
      :style="{
        top: `${index / 4}rem`,
        left: `${index / 4}rem`,
        zIndex: docs.length - index,
      }"
    >
      {{ toMoney(doc.trip?.price ?? 0) }}
    </div>
  </article>
</template>

<script setup lang="ts">
import { clamp } from 'lodash-es'

const DOCS_DISPLAY_MAX = 3

const props = defineProps<{
  item: MapItemAccom
  selected?: boolean
  visited?: boolean
}>()

const confData = useConfdata()
const { toMoney } = useMoneyFormat(() => confData.currency)

const count = computed(() => clamp(props.item.count, 1, DOCS_DISPLAY_MAX))
const docs = computed(() => props.item.docs?.slice(0, count.value) ?? [])
</script>
